import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.16 Case 16</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_16"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 16. This is a negative case.
                Beginning at the level of the cerebellum and moving superiorly,
                we enter into the temporal and occipital regions, seen here.
                White matter tracts are delineated on the left as well as on the
                right, coursing through the temporal and occipital regions. Less
                intense activity is seen in the adjacent gray matter on both
                sides. gray-white contrast is preserved bilaterally. This
                pattern continues throughout the temporal and occipital regions,
                as seen here.
              </p>
              <p>
                Entering into the frontal cortices, intense uptake is seen in
                these fingerlike projections of white matter on the left as well
                as on the right. Less intense activity is seen surrounding the
                white matter. It is important to ensure that the less intense
                activity is within the gray matter and not secondary to atrophy.
                Utilizing the fused images, you can readily see that the less
                intense activity is still within the gray matter and not due to
                CSF space. Although there is mild atrophy present, identified
                here as well as here, the less intense activity seen corresponds
                to gray matter. Therefore there is preserved gray-white contrast
                in the frontal cortices bilaterally.
              </p>
              <p>
                At this level, white matter tracts are easily delineated,
                coursing from the front of the brain to the back of the brain on
                the left as well as on the right. In the posterior parietal
                region, seen here, distinct white matter tracts are also
                identified, and less intense activity is seen in the gray
                matter. There is no loss of gray-white contrast. In the superior
                parietal region, again white matter tracts are seen on the right
                as well as on the left, and as we enter into the medial parietal
                region, including the precuneus, seen here, no intense activity
                is seen in the gray matter. As there is no loss of gray-white
                contrast in any region, this case is negative, even with the
                presence of mild atrophy. If you called this case positive, you
                may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-15"
          nextLesson="/module-4/module-4-1-17"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1460450575&entry_id=1_aum9fgsi&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_aum9fgsi"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
